import { loading, success, failure } from 'utilities/actions'
import { put, takeLatest, all, fork, select } from 'redux-saga/effects'
import * as actions from './actions'

import { API_URL, ENROLMENTS_ENDPOINT } from 'qap/constants'
import { requestActions } from 'state/request'

import { stringify } from 'utilities/apiQueryString'

export function* fetchEnrolments(action: any): Generator<any, any, any> {
  const { filter, page, sort } = yield select(state => state.enrolments)
  const queryString = stringify({ filter, page, sort })

  const url = `${API_URL}/${ENROLMENTS_ENDPOINT}?${queryString ? `&${queryString}` : ''}`

  yield put({
    type: loading(actions.API_ENROLMENTS_INDEX)
  })

  yield put({
    type: requestActions.AUTHED_REQUEST,
    method: 'GET',
    url,
    cancelKey: 'enrolments.index',
    successAction: success(actions.API_ENROLMENTS_INDEX),
    failureAction: failure(actions.API_ENROLMENTS_INDEX)
  })
}

export function* fetchEnrolmentFacets(action: any): Generator<any, any, any> {
  const { filter } = yield select(state => state.enrolments)

  const queryString = stringify({ filter })
  const url = `${API_URL}/${ENROLMENTS_ENDPOINT}/facets?${queryString ? `&${queryString}` : ''}`

  yield put({
    type: requestActions.AUTHED_REQUEST,
    method: 'GET',
    url,
    cancelKey: 'enrolments.facets',
    successAction: actions.API_ENROLMENTS_FACETS_INDEX_SUCCESS,
    failureAction: actions.API_ENROLMENTS_FACETS_INDEX_FAILURE
  })
}

export function* fetchAllEnrolmentFacets(): Generator<any, any, any> {
  const url = `${API_URL}/${ENROLMENTS_ENDPOINT}/facets`

  yield put({
    type: requestActions.AUTHED_REQUEST,
    method: 'GET',
    url,
    cancelKey: 'enrolments.allFacets',
    hideLoading: true,
    skipGlobalErrorHandling: true,
    successAction: actions.API_ENROLMENTS_ALL_FACETS_INDEX_SUCCESS,
    failureAction: actions.API_ENROLMENTS_ALL_FACETS_INDEX_FAILURE
  })
}

function* watchFetch(): Generator<any, any, any> {
  yield takeLatest([
    actions.API_ENROLMENTS_FACETS_INDEX,
    actions.API_ENROLMENTS_SET_ALL_FILTERS
  ], fetchEnrolmentFacets)

  yield takeLatest([
    actions.API_ENROLMENTS_INDEX,
    actions.API_ENROLMENTS_SET_ALL_FILTERS
  ], fetchEnrolments)

  yield takeLatest([
    actions.API_ENROLMENTS_ALL_FACETS_INDEX
  ], fetchAllEnrolmentFacets)
}

export default function* enrolmentsSagas(): Generator<any, any, any> {
  yield all([
    fork(watchFetch)
  ])
}
